import capabilityClaims from '#assets/base-icons/capabilityClaims.svg';
import capabilityClaimsFilled from '#assets/base-icons/capabilityClaimsFilled.svg';
import capabilityGroupChallenges from '#assets/base-icons/capabilityGroupChallenges.svg';
import capabilityHome from '#assets/base-icons/capabilityHome.svg';
import capabilityHomeFilled from '#assets/base-icons/capabilityHomeFilled.svg';
import capabilityJourney from '#assets/base-icons/capabilityJourney.svg';
import capabilityJourneyFilled from '#assets/base-icons/capabilityJourneyFilled.svg';
import capabilityMarketplace from '#assets/base-icons/capabilityMarketplace.svg';
import capabilityProfile from '#assets/base-icons/capabilityProfile.svg';
import capabilityProfileFilled from '#assets/base-icons/capabilityProfileFilled.svg';
import capabilityWallet from '#assets/base-icons/capabilityWallet.svg';
import capabilityWalletFilled from '#assets/base-icons/capabilityWalletFilled.svg';
import capabilityCare from '#assets/base-icons/capabilityCare.svg';
import capabilityCareActive from '#assets/base-icons/capabilityCareActive.svg';
import descriptiveAlarmClock from '#assets/base-icons/descriptiveAlarmClock.svg';
import descriptiveAmbulance from '#assets/base-icons/descriptiveAmbulance.svg';
import descriptiveAttachment from '#assets/base-icons/descriptiveAttachment.svg';
import descriptiveBuildings from '#assets/base-icons/descriptiveBuildings.svg';
import descriptiveCalendar from '#assets/base-icons/descriptiveCalendar.svg';
import descriptiveCaregiver from '#assets/base-icons/descriptiveCaregiver.svg';
import descriptiveCareFacility from '#assets/base-icons/descriptiveCareFacility.svg';
import descriptiveCareProvider from '#assets/base-icons/descriptiveCareProvider.svg';
import descriptiveChatHistory from '#assets/base-icons/descriptiveChatHistory.svg';
import descriptiveCheckBadge from '#assets/base-icons/descriptiveCheckBadge.svg';
import descriptiveClock from '#assets/base-icons/descriptiveClock.svg';
import descriptiveCompose from '#assets/base-icons/descriptiveCompose.svg';
import descriptiveCreditCardPayment from '#assets/base-icons/descriptiveCreditCardPayment.svg';
import descriptiveDocument from '#assets/base-icons/descriptiveDocument.svg';
import descriptiveFaceID from '#assets/base-icons/descriptiveFaceID.svg';
import descriptiveFilter from '#assets/base-icons/descriptiveFilter.svg';
import descriptiveFlag from '#assets/base-icons/descriptiveFlag.svg';
import descriptiveGraphTrendingUp from '#assets/base-icons/descriptiveGraphTrendingUp.svg';
import descriptiveHealthClipboard from '#assets/base-icons/descriptiveHealthClipboard.svg';
import descriptiveHealthClipboardFilled from '#assets/base-icons/descriptiveHealthClipboardFilled.svg';
import descriptiveHeart from '#assets/base-icons/descriptiveHeart.svg';
import descriptiveHeartFilled from '#assets/base-icons/descriptiveHeartFilled.svg';
import descriptiveHeartRateUp from '#assets/base-icons/descriptiveHeartRateUp.svg';
import descriptiveHome from '#assets/base-icons/descriptiveHome.svg';
import descriptiveHome2 from '#assets/base-icons/descriptiveHome2.svg';
import descriptiveHomeFilled from '#assets/base-icons/descriptiveHomeFilled.svg';
import descriptiveInformationDesk from '#assets/base-icons/descriptiveInformationDesk.svg';
import descriptiveInsurance from '#assets/base-icons/descriptiveInsurance.svg';
import descriptiveLocationCompass from '#assets/base-icons/descriptiveLocationCompass.svg';
import descriptiveLocationPin from '#assets/base-icons/descriptiveLocationPin.svg';
import descriptiveList from '#assets/base-icons/descriptiveList.svg';
import descriptiveLock from '#assets/base-icons/descriptiveLock.svg';
import descriptiveLockPerson from '#assets/base-icons/descriptiveLockPerson.svg';
import descriptiveLockShield from '#assets/base-icons/descriptiveLockShield.svg';
import descriptiveLockTree from '#assets/base-icons/descriptiveLockTree.svg';
import descriptiveMail from '#assets/base-icons/descriptiveMail.svg';
import descriptiveMapSearch from '#assets/base-icons/descriptiveMapSearch.svg';
import descriptiveMobileAlertUser from '#assets/base-icons/descriptiveMobileAlertUser.svg';
import descriptiveMoneyBill from '#assets/base-icons/descriptiveMoneyBill.svg';
import descriptiveNotifications from '#assets/base-icons/descriptiveNotifications.svg';
import descriptiveParking from '#assets/base-icons/descriptiveParking.svg';
import descriptivePaymentCard from '#assets/base-icons/descriptivePaymentCard.svg';
import descriptivePeople from '#assets/base-icons/descriptivePeople.svg';
import descriptivePerson from '#assets/base-icons/descriptivePerson.svg';
import descriptivePersonalInfo from '#assets/base-icons/descriptivePersonalInfo.svg';
import descriptivePersonFilled from '#assets/base-icons/descriptivePersonFilled.svg';
import descriptivePhone from '#assets/base-icons/descriptivePhone.svg';
import descriptivePill from '#assets/base-icons/descriptivePill.svg';
import descriptivePillFilled from '#assets/base-icons/descriptivePillFilled.svg';
import descriptiveQuestionBox from '#assets/base-icons/descriptiveQuestionBox.svg';
import descriptiveSecurityLock from '#assets/base-icons/descriptiveSecurityLock.svg';
import descriptiveSettings from '#assets/base-icons/descriptiveSettings.svg';
import descriptiveShop from '#assets/base-icons/descriptiveShop.svg';
import descriptiveShopFilled from '#assets/base-icons/descriptiveShopFilled.svg';
import descriptiveStarRibbon from '#assets/base-icons/descriptiveStarRibbon.svg';
import descriptiveStudentRecertification from '#assets/base-icons/descriptiveStudentRecertification.svg';
import descriptiveSupportQuestionChat from '#assets/base-icons/descriptiveSupportQuestionChat.svg';
import descriptiveSupportQuestionChatFilled from '#assets/base-icons/descriptiveSupportQuestionChatFilled.svg';
import descriptiveTouchID from '#assets/base-icons/descriptiveTouchID.svg';
import descriptiveTransitBus from '#assets/base-icons/descriptiveTransitBus.svg';
import descriptiveUmbrella from '#assets/base-icons/descriptiveUmbrella.svg';
import descriptiveWebsite from '#assets/base-icons/descriptiveWebsite.svg';
import descriptiveWheelchairAccessibility from '#assets/base-icons/descriptiveWheelchairAccessibility.svg';
import interfaceArrowDown from '#assets/base-icons/interfaceArrowDown.svg';
import interfaceArrowLeft from '#assets/base-icons/interfaceArrowLeft.svg';
import interfaceArrowRight from '#assets/base-icons/interfaceArrowRight.svg';
import interfaceArrowUp from '#assets/base-icons/interfaceArrowUp.svg';
import interfaceChange from '#assets/base-icons/interfaceChange.svg';
import interfaceCheckbox from '#assets/base-icons/interfaceCheckbox.svg';
import interfaceCheckmark from '#assets/base-icons/interfaceCheckmark.svg';
import interfaceChevronDown from '#assets/base-icons/interfaceChevronDown.svg';
import interfaceChevronLeft from '#assets/base-icons/interfaceChevronLeft.svg';
import interfaceChevronRight from '#assets/base-icons/interfaceChevronRight.svg';
import interfaceChevronUp from '#assets/base-icons/interfaceChevronUp.svg';
import interfaceClose from '#assets/base-icons/interfaceClose.svg';
import interfaceCopy from '#assets/base-icons/interfaceCopy.svg';
import interfaceDelete from '#assets/base-icons/interfaceDelete.svg';
import interfaceDownload from '#assets/base-icons/interfaceDownload.svg';
import interfaceEdit from '#assets/base-icons/interfaceEdit.svg';
import interfaceEndKey from '#assets/base-icons/interfaceEndKey.svg';
import interfaceExternalLink from '#assets/base-icons/interfaceExternalLink.svg';
import interfaceExternalShare from '#assets/base-icons/interfaceExternalShare.svg';
import interfaceFirst from '#assets/base-icons/interfaceFirst.svg';
import interfaceHidden from '#assets/base-icons/interfaceHidden.svg';
import interfaceHomeKey from '#assets/base-icons/interfaceHomeKey.svg';
import interfaceLast from '#assets/base-icons/interfaceLast.svg';
import interfaceMeatballs from '#assets/base-icons/interfaceMeatballs.svg';
import interfaceMenu from '#assets/base-icons/interfaceMenu.svg';
import interfaceMinus from '#assets/base-icons/interfaceMinus.svg';
import interfacePlay from '#assets/base-icons/interfacePlay.svg';
import interfacePlus from '#assets/base-icons/interfacePlus.svg';
import interfacePrint from '#assets/base-icons/interfacePrint.svg';
import interfaceQuestionCircle from '#assets/base-icons/interfaceQuestionCircle.svg';
import interfaceQuestionCircleFilled from '#assets/base-icons/interfaceQuestionCircleFilled.svg';
import interfaceRefresh from '#assets/base-icons/interfaceRefresh.svg';
import interfaceSearch from '#assets/base-icons/interfaceSearch.svg';
import interfaceSignOut from '#assets/base-icons/interfaceSignOut.svg';
import interfaceStar from '#assets/base-icons/interfaceStar.svg';
import interfaceStop from '#assets/base-icons/interfaceStop.svg';
import interfaceURL from '#assets/base-icons/interfaceURL.svg';
import interfaceVisible from '#assets/base-icons/interfaceVisible.svg';
import statusAlert from '#assets/base-icons/statusAlert.svg';
import statusAlertFill from '#assets/base-icons/statusAlertFill.svg';
import statusErrorStatus from '#assets/base-icons/statusErrorStatus.svg';
import statusErrorStatusFilled from '#assets/base-icons/statusErrorStatusFilled.svg';
import statusInformationCircle from '#assets/base-icons/statusInformationCircle.svg';
import statusInformationCircle2 from '#assets/base-icons/statusInformationCircle2.svg';
import statusInformationCircle2Filled from '#assets/base-icons/statusInformationCircle2Filled.svg';
import statusInformationCircleFill from '#assets/base-icons/statusInformationCircleFill.svg';
import statusSuccessStatus from '#assets/base-icons/statusSuccessStatus.svg';
import statusLightStatus from '#assets/base-icons/statusLightStatus.svg';
import statusSuccessStatusFilled from '#assets/base-icons/statusSuccessStatusFilled.svg';
import tinyAlert from '#assets/base-icons/tinyAlert.svg';
import tinyBackButton from '#assets/base-icons/tinyBackButton.svg';
import tinyCircleStar from '#assets/base-icons/tinyCircleStar.svg';
import tinyClear from '#assets/base-icons/tinyClear.svg';
import tinyClose from '#assets/base-icons/tinyClose.svg';
import tinyDisclosureIndicator from '#assets/base-icons/tinyDisclosureIndicator.svg';
import tinyExternalLink from '#assets/base-icons/tinyExternalLink.svg';
import tinyHelper from '#assets/base-icons/tinyHelper.svg';
import tinyHelperFilled from '#assets/base-icons/tinyHelperFilled.svg';
import tinyNewWindowInternal from '#assets/base-icons/tinyNewWindowInternal.svg';
import tinyStar from '#assets/base-icons/tinyStar.svg';
import tinyValidationCheck from '#assets/base-icons/tinyValidationCheck.svg';

const CAPABILITY_ICONS = {
  capabilityGroupChallenges,
  capabilityHome,
  capabilityHomeFilled,
  capabilityJourney,
  capabilityJourneyFilled,
  capabilityMarketplace,
  capabilityProfile,
  capabilityProfileFilled,
  capabilityWallet,
  capabilityWalletFilled,
  capabilityClaims,
  capabilityClaimsFilled,
  capabilityCare,
  capabilityCareActive,
};

const DESCRIPTIVE_ICONS = {
  descriptiveAlarmClock,
  descriptiveAmbulance,
  descriptiveAttachment,
  descriptiveBuildings,
  descriptiveCalendar,
  descriptiveCareFacility,
  descriptiveCaregiver,
  descriptiveCareProvider,
  descriptiveChatHistory,
  descriptiveCheckBadge,
  descriptiveClock,
  descriptiveCompose,
  descriptiveCreditCardPayment,
  descriptiveDocument,
  descriptiveFaceID,
  descriptiveFilter,
  descriptiveFlag,
  descriptiveGraphTrendingUp,
  descriptiveHealthClipboard,
  descriptiveHealthClipboardFilled,
  descriptiveHeart,
  descriptiveHeartFilled,
  descriptiveHeartRateUp,
  descriptiveHome,
  descriptiveHome2,
  descriptiveHomeFilled,
  descriptiveInformationDesk,
  descriptiveInsurance,
  descriptiveList,
  descriptiveLocationCompass,
  descriptiveLocationPin,
  descriptiveLock,
  descriptiveLockPerson,
  descriptiveLockShield,
  descriptiveLockTree,
  descriptiveMail,
  descriptiveMapSearch,
  descriptiveMobileAlertUser,
  descriptiveMoneyBill,
  descriptiveNotifications,
  descriptiveParking,
  descriptivePaymentCard,
  descriptivePeople,
  descriptivePerson,
  descriptivePersonalInfo,
  descriptivePersonFilled,
  descriptivePhone,
  descriptivePill,
  descriptivePillFilled,
  descriptiveQuestionBox,
  descriptiveSecurityLock,
  descriptiveSettings,
  descriptiveShop,
  descriptiveShopFilled,
  descriptiveStarRibbon,
  descriptiveStudentRecertification,
  descriptiveSupportQuestionChat,
  descriptiveSupportQuestionChatFilled,
  descriptiveTouchID,
  descriptiveTransitBus,
  descriptiveUmbrella,
  descriptiveWebsite,
  descriptiveWheelchairAccessibility,
};

const INTERFACE_ICONS = {
  interfaceArrowDown,
  interfaceArrowLeft,
  interfaceArrowRight,
  interfaceArrowUp,
  interfaceChange,
  interfaceCheckbox,
  interfaceCheckmark,
  interfaceChevronDown,
  interfaceChevronLeft,
  interfaceChevronRight,
  interfaceChevronUp,
  interfaceClose,
  interfaceCopy,
  interfaceDelete,
  interfaceDownload,
  interfaceEdit,
  interfaceEndKey,
  interfaceExternalLink,
  interfaceExternalShare,
  interfaceFirst,
  interfaceHidden,
  interfaceHomeKey,
  interfaceLast,
  interfaceMeatballs,
  interfaceMenu,
  interfaceMinus,
  interfacePlay,
  interfacePlus,
  interfacePrint,
  interfaceQuestionCircle,
  interfaceQuestionCircleFilled,
  interfaceRefresh,
  interfaceSearch,
  interfaceSignOut,
  interfaceStar,
  interfaceStop,
  interfaceURL,
  interfaceVisible,
};

const STATUS_ICONS = {
  statusAlert,
  statusAlertFill,
  statusErrorStatus,
  statusErrorStatusFilled,
  statusInformationCircle,
  statusInformationCircle2,
  statusInformationCircle2Filled,
  statusInformationCircleFill,
  statusSuccessStatus,
  statusSuccessStatusFilled,
  statusLightStatus,
};

const TINY_ICONS = {
  tinyAlert,
  tinyBackButton,
  tinyCircleStar,
  tinyClear,
  tinyClose,
  tinyDisclosureIndicator,
  tinyExternalLink,
  tinyHelper,
  tinyHelperFilled,
  tinyNewWindowInternal,
  tinyStar,
  tinyValidationCheck,
};

// Original Genesis Core icon set
export const BASE_ICON_MAP = {
  ...CAPABILITY_ICONS,
  ...DESCRIPTIVE_ICONS,
  ...INTERFACE_ICONS,
  ...STATUS_ICONS,
  ...TINY_ICONS,
};
